export default "__VITE_ASSET__Da6ichM8__"